import { Button as MuiButton } from '@mui/material';
import styled from '@mui/material/styles/styled';

import { colors } from 'styles/colors';

type ButtonType = 'primary' | 'secondary' | 'tertiary';

interface ButtonProps {
  btnType?: ButtonType;
  width?: number | 'full';
  height?: number;
  px?: number;
}

export const Button = styled(MuiButton)<ButtonProps>(
  ({ btnType = 'primary', height = 56, width, px = 24 }) => ({
    padding: `12px ${px}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    lineHeight: '150%',
    textTransform: 'none',
    borderRadius: '4px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    width: width ? (width === 'full' ? '100%' : `${width}px`) : 'auto',
    height: `${height}px`,
    color: colors.white,
    transition: 'all 0.25s ease',

    '& a': {
      color: colors.white,
      textDecoration: 'none',

      '&:hover, &:visited, &:active, &:link': {
        color: colors.white,
      },
    },

    ...(btnType === 'primary' && {
      backgroundColor: colors.blue,
      '&:hover': {
        backgroundColor: colors.blueHover,
      },
      '&.Mui-disabled': {
        backgroundColor: '#aacaf0',
        color: colors.white,
      },
    }),

    ...(btnType === 'secondary' && {
      backgroundColor: colors.secondaryButton,
      border: `1px solid ${colors.white}`,
      '&:hover': {
        backgroundColor: colors.secondaryButtonHover,
        border: `1px solid ${colors.blue}`,
      },
      '&.Mui-disabled': {
        backgroundColor: colors.secondaryButton,
        color: colors.secondaryButtonDisabled,
        border: `1px solid ${colors.secondaryButtonDisabledBordder}`,
      },
    }),

    ...(btnType === 'tertiary' && {
      backgroundColor: colors.textPrimary,
      '&:hover': {
        backgroundColor: colors.mainDark,
      },
      '&.Mui-disabled': {
        backgroundColor: colors.secondaryButtonDisabledBordder,
      },
    }),
  }),
);
